import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';

import android from '../assets/icons/device/Android.png';
import hisense from '../assets/icons/device/Hisense.png';
import lenovo from '../assets/icons/device/Lenovo.png';
import vizio from '../assets/icons/device/VIZIO.png';
import windows from '../assets/icons/device/Windows.png';
import androidtv from '../assets/icons/device/androidtv.png';
import apple from '../assets/icons/device/apple.png';
import chrome from '../assets/icons/device/chrome.png';
import firetv from '../assets/icons/device/firetv.png';
import formuler from '../assets/icons/device/formuler.png';
import huawei from '../assets/icons/device/huawei.png';
import lg from '../assets/icons/device/lg.png';
import philips from '../assets/icons/device/philips.png';
import roku from '../assets/icons/device/roku.png';
import samsung from '../assets/icons/device/samsung.png';
import sharp from '../assets/icons/device/sharp.png';
import sony from '../assets/icons/device/sony.png';
import tcl from '../assets/icons/device/tcl.png';
import toshiba from '../assets/icons/device/toshiba.png';
import x96 from '../assets/icons/device/x96.png';
import xiaomi from '../assets/icons/device/xiaomi.png';

const DEVICES = [
    { name: 'Android', icon: android },
    { name: 'Apple', icon: apple },
    { name: 'Windows', icon: windows },
    { name: 'Samsung', icon: samsung },
    { name: 'LG', icon: lg },
    { name: 'Sony', icon: sony },
    { name: 'Android TV', icon: androidtv },
    { name: 'Fire TV', icon: firetv },
    { name: 'Roku', icon: roku },
    { name: 'Chromecast', icon: chrome },
    { name: 'Hisense', icon: hisense },
    { name: 'TCL', icon: tcl },
    { name: 'Philips', icon: philips },
    { name: 'Toshiba', icon: toshiba },
    { name: 'Xiaomi', icon: xiaomi },
    { name: 'Huawei', icon: huawei },
    { name: 'Lenovo', icon: lenovo },
    { name: 'Vizio', icon: vizio },
    { name: 'Formuler', icon: formuler },
    { name: 'Sharp', icon: sharp },
    { name: 'X96', icon: x96 },
];

export default function Devices() {
    return (
        <Section id="appareils" className="border-y border-line bg-ink-900/40">
            <SectionHeading
                eyebrow="Compatibilité"
                title="Fonctionne sur les appareils que vous avez déjà"
                description="Smart TV, boîtier Android, Fire Stick, ordinateur ou smartphone : aucun matériel supplémentaire n'est nécessaire."
            />

            <ul className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7">
                {DEVICES.map((device, index) => (
                    <Reveal as="li" key={device.name} delay={Math.min(index * 30, 300)}>
                        <div className="group flex h-20 flex-col items-center justify-center gap-2 rounded-xl border border-line bg-surface-raised/60 px-3 transition-[transform,border-color,background-color] duration-300 ease-smooth hover:-translate-y-1 hover:border-line-strong hover:bg-surface-raised">
                            <img
                                src={device.icon}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                                decoding="async"
                                className="max-h-7 w-auto max-w-[70%] object-contain brightness-0 invert transition-opacity duration-300 opacity-60 group-hover:opacity-100"
                            />
                            <span className="text-[0.6875rem] font-medium text-content-subtle transition-colors group-hover:text-content-muted">
                                {device.name}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </ul>
        </Section>
    );
}
